import {
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
    AlphaAttribute,
} from '../attributes';
import { TimeInvariantBase } from '../TimeInvariantBase';

/**
 * ColorStops are individual stops in a gradient. They identify the color and the relative offset at which the color
 * should appear.
 */
export class ColorStop extends TimeInvariantBase {
    override _classType = 'ColorStop';
    override _name = 'ColorStop';
    @ColorAttribute()
    accessor color: number = 0;
    @NumberAttribute({ min: 0, max: 1 })
    accessor offset = 0;
    @AlphaAttribute()
    accessor alpha = 1;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-useless-constructor
    constructor(settings: any) {
        super(settings);
    }

    override get readonlyProperties(): string[] {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }
}
